"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Caption1: function() {
        return _Caption1.Caption1;
    },
    caption1ClassNames: function() {
        return _useCaption1Stylesstyles.caption1ClassNames;
    }
});
const _Caption1 = require("./Caption1");
const _useCaption1Stylesstyles = require("./useCaption1Styles.styles");
